import styled from "@emotion/styled";

export const Header = styled.div`
  grid-area: header;
  background: var(--bg);
`;
